import React from 'react';
import {Disclosure} from '@headlessui/react';
import type {AstView, EnrichedAstNode} from 'rendition-core';
import classNames from 'classnames';

import {Chevron} from 'Icons/Chevron';
import {DocumentControls} from './DocumentControls';
import {EditControls} from './EditControls';

import type {WebflowControls} from '../useWebflowJSON';
import {useProductContext} from 'Contexts/ProductContext';

interface Props {
    view: AstView;
    setView: (view: AstView) => void;
    selectedNodes: EnrichedAstNode[];
    selectedNodeIds: string[];
    loadingCode: boolean;
    id: string;
    doGetCode: () => void;
    webflowControls: WebflowControls;
    onSelectNodes: (ids: string[]) => void;
}

export const RightRail: React.FC<Props> = ({
    id,
    loadingCode,
    webflowControls,
    view,
    doGetCode,
    selectedNodeIds,
    selectedNodes,
    onSelectNodes,
    setView,
}) => {
    const {mode} = useProductContext();
    return (
        <>
            <div
                className={classNames(
                    'absolute right-2 top-2 z-[998] flex w-80 flex-col gap-3 rounded-lg bg-zinc-900',
                    mode === 'Rendition_Code' ? 'bottom-[120px]' : 'bottom-2'
                )}
            >
                <div className="h-full overflow-y-scroll p-4 pb-20">
                    {mode === 'Rendition' && (
                        <Disclosure defaultOpen>
                            {({open}) => (
                                <>
                                    <Disclosure.Button className="flex w-full flex-row flex-nowrap items-center justify-between fill-white px-4 py-2 text-[12px] font-semibold text-neutral-300 hover:bg-sky-500/40">
                                        Controls
                                        <Chevron width={15} height={15} direction={open ? 'up' : 'down'} />
                                    </Disclosure.Button>
                                    <Disclosure.Panel>
                                        <div className="flex w-full flex-col gap-3">
                                            <DocumentControls
                                                id={id}
                                                loadingCode={loadingCode}
                                                webflowControls={webflowControls}
                                                view={view}
                                                onGetCode={doGetCode}
                                                selectedId={selectedNodeIds[0]}
                                            />
                                            {/* {selectedNodes.length === 1 && process.env.REACT_APP_DEV_DEBUG_MODE && (
                                            <pre className="text-white">
                                                id: {selectedNodes[0].internalId}
                                                inner: {JSON.stringify(selectedNodes[0].innerPosition, null, 2)}
                                                outer: {JSON.stringify(selectedNodes[0].position, null, 2)}
                                            </pre>
                                        )} */}
                                        </div>
                                    </Disclosure.Panel>
                                </>
                            )}
                        </Disclosure>
                    )}
                    <EditControls
                        view={view}
                        setView={setView}
                        selectedNodes={selectedNodes}
                        onSelectNodes={onSelectNodes}
                    />
                </div>
            </div>
        </>
    );
};
